export default ($axios, baseUrl) => ({
  getStripeToken(billingInfo, items, currency, locale, promoCode = null) {
    return $axios.post(`${baseUrl}subscriptions/stripe/gettoken`, {
      BillingInfo: billingInfo,
      Items: items,
      Currency: currency,
      Locale: locale,
      PromoCode: promoCode,
    })
  },
  getPayPalCheckoutToken(billingInfo, productId, currency, promoCode = null) {
    return $axios.post(`${baseUrl}subscriptions/paypalcheckout/gettoken`, {
      BillingInfo: billingInfo,
      ProductId: productId,
      Currency: currency,
      PromoCode: promoCode,
    })
  },
  getBraintreeToken(billingInfo, currency) {
    return $axios.post(`${baseUrl}subscriptions/braintree/gettoken`, {
      BillingInfo: billingInfo,
      Currency: currency,
    })
  },
  getStripePaymentInfo(intentId) {
    return $axios.post(`${baseUrl}subscriptions/stripe/details`, { IntentId: intentId })
  },
  getPayPalCheckoutPaymentInfo(orderId, subscriptionId, token) {
    return $axios.post(`${baseUrl}subscriptions/paypalcheckout/details`, { OrderId: orderId, SubscriptionId: subscriptionId, Token: token })
  },
  updateContactInfo(billingInfo) {
    return $axios.post(`${baseUrl}subscriptions/contactinfo/update`, billingInfo)
  },
  getPromoCodeInfo(promoCode) {
    return $axios.post(`${baseUrl}subscriptions/promocodes/get`, { Code: promoCode })
  },
  getOrderInfo(transactionId) {
    return $axios.post(`${baseUrl}subscriptions/payments/orderinfo`, { TransactionId: transactionId })
  },
  processPayPalSubscriptionPurchased(subscriptionId, promoCode) {
    return $axios.post(`${baseUrl}subscriptions/paypalcheckout/process`, { BillingAgreementId: subscriptionId, PromoCode: promoCode })
  },
  createPayPalCheckoutOrder(products, currency, promoCode) {
    return $axios.post(`${baseUrl}payments/paypalcheckout/createorder`, {
      Products: products.map((x) => ({ ProductId: x, Quantity: 1 })),
      PromoCode: promoCode,
      Currency: currency,
    })
  },
  capturePayPalCheckoutOrder(orderId) {
    return $axios.post(`${baseUrl}payments/paypalcheckout/captureorder`, { OrderId: orderId })
  },
  processPayPalOrderPurchased(orderId, promoCode, currency, email, products) {
    return $axios.post(`${baseUrl}payments/paypalcheckout/orderpurchased`, {
      Products: products.map((x) => ({ ProductId: x, Quantity: 1 })),
      PromoCode: promoCode,
      Currency: currency,
      Email: email,
      OrderId: orderId,
    })
  },
  processBraintreeSubscriptionPurchased(email, nonce, productId, currency, promoCode) {
    return $axios.post(`${baseUrl}subscriptions/braintree/process`, {
      Email: email,
      Nonce: nonce,
      ProductId: productId,
      Currency: currency,
      PromoCode: promoCode,
    })
  },
  processBraintreeProductsPurchase(email, nonce, products, currency, promoCode) {
    return $axios.post(`${baseUrl}payments/braintree/process`, {
      Email: email,
      Nonce: nonce,
      Products: products.map((x) => ({ ProductId: x.ProductId, Quantity: 1 })),
      Currency: currency,
      PromoCode: promoCode,
    })
  },
})
